// extracted by css-extract-rspack-plugin
export default {"Container":"BranchDescription-module__Container__XwtqV","ActionGroup":"BranchDescription-module__ActionGroup__OraDG"};